import { defineMessages } from 'react-intl'

export default defineMessages({
  userInfoTitle: {
    id: 'components.OrganizationPicker.UserInfo.userInfoTitle',
    defaultMessage: 'All my active access',
  },
})
